import Vue from 'vue';
export const arrowKeyNavigationMixin = Vue.extend({

  data() {
    return {
      currentIndex: 0,
    };
  },

  // method for handling keyboard navigation on dropdowns like terminal selector or customer selector
  // Up/Down arrow to cycle through available options - when cycling past the last option it will loop back to the first
  // Enter/Space to confirm selection
  methods: {
    handleArrowKeysOnDropdowns(this: { dropdownOpened: boolean, $el: HTMLElement }, event: KeyboardEvent): void {

      if (!['ArrowDown', 'ArrowUp', 'Enter', ' ', 'Tab'].includes(event.key)) return;
      if (!this.$el.contains(event.target as Node)) return;

      if (this.dropdownOpened !== undefined && !this.dropdownOpened) return;

      const focusableItems = Array.from(
        this.$el.querySelectorAll<HTMLElement>(
          '.dropdown-item, .num-selector__button:not(.num-selector__button--disabled), button.button-primary, .icon-button--close'
        )
      );

      if (!focusableItems.length) return;

      const activeIndex = focusableItems.indexOf(document.activeElement as HTMLElement);
      let nextIndex = activeIndex;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (activeIndex !== -1) (focusableItems[activeIndex] as HTMLElement).click();
        return;
      }

      event.preventDefault();

      if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey)) {
        nextIndex = (activeIndex + 1) % focusableItems.length;
      } else if (event.key === 'ArrowUp' || (event.key === 'Tab' && event.shiftKey)) {
        nextIndex = (activeIndex - 1 + focusableItems.length) % focusableItems.length;
      }
      focusableItems[nextIndex].focus();
    },
  },

  mounted() {
    document.addEventListener('keydown', this.handleArrowKeysOnDropdowns as unknown as EventListener);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleArrowKeysOnDropdowns as unknown as EventListener);
  },
});
